import React from 'react';
import { Message } from '../types/booking';
import { TherapistCard } from './TherapistCard';
interface ChatMessageProps {
  message: Message;
  onOptionClick?: (option: string) => void;
}
export function ChatMessage({
  message,
  onOptionClick
}: ChatMessageProps) {
  const isBot = message.sender === 'bot';
  const handleTherapistBook = (therapistName: string, time: string) => {
    onOptionClick?.(`${therapistName} - ${time}`);
  };
  return <div className={`flex ${isBot ? 'justify-start' : 'justify-end'} mb-4`} data-id="element-30">
      <div className="max-w-[80%]" data-id="element-31">
        <div className={`rounded-2xl px-4 py-3 ${isBot ? 'bg-gray-100 text-gray-800' : 'bg-purple-600 text-white'}`} data-id="element-32">
          <p className="text-sm whitespace-pre-line" data-id="element-33">{message.text}</p>
        </div>
        {message.therapists && message.therapists.length > 0 && <div className="flex flex-col gap-3 mt-4" data-id="element-34">
            {message.therapists.map((therapist, index) => <TherapistCard key={`${therapist.name}-${therapist.time}-${index}`} therapist={therapist} onBook={handleTherapistBook} data-id="element-35" />)}
          </div>}
        {message.options && message.options.length > 0 && <div className="flex flex-wrap gap-2 mt-3" data-id="element-36">
            {message.options.map((option, index) => <button key={index} onClick={() => onOptionClick?.(option)} className="px-4 py-2 bg-white border-2 border-purple-600 text-purple-600 rounded-full text-sm font-medium hover:bg-purple-50 transition-colors" data-id="element-37">
                {option}
              </button>)}
          </div>}
        <p className="text-xs text-gray-400 mt-1 px-2" data-id="element-38">
          {message.timestamp.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })}
        </p>
      </div>
    </div>;
}